module.exports = __webpack_public_path__ + "img/img53.6b47f907.svg";